export const STORAGE_KEY = 'feedback-form-state';
export const store = { email: '', message: '' };
